import { showOrganization } from 'modules/subscribers/actions';
import { toastError, toastSuccess } from 'partial/components/react-geek-toast';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { getUpgradeRequestList, updateUpgradeRequest } from './actions';

export const useUpgradeRequestList = (params) => {
  const {
    data: raw,
    isLoading,
    isRefetching,
  } = useQuery({
    queryKey: ['get-upgrade-request-list', params],
    queryFn: getUpgradeRequestList,
    retry: false,
    keepPreviousData: true,
  });
  const data = raw?.data?.data;
  const meta = raw?.data?.meta;
  return [isLoading, data, meta, isRefetching];
};

export const useShowOrganization = (uuid) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['show-subscriber-organization', uuid],
    queryFn: showOrganization,
    retry: false,
    keepPreviousData: true,
    enabled: !!uuid,
  });
  const data = raw?.data?.data;
  return [isLoading, data];
};

export const useUpdateRequest = ({ onSuccess, onError }) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(updateUpgradeRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries('get-upgrade-request-list');
      toastSuccess('Successfully updated upgrade request!');
      if (typeof onSuccess === 'function') onSuccess();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};
